import styled from '@emotion/styled';
import { IBreadcrumbItems } from '@shared/models/components/IBreadcrumb';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import Breadcrumb from '../structure/Breadcrumb';
import { Tag } from '../text/ContentTypography';
import { BodyMedium, DisplayLarge, LightSmall } from '../text/Typography';
import { HeaderChildWrap, HeaderTextWrap } from './CommonHeaderStyles';

export interface IPageHeaderProps {
    title: string | React.ReactNode;
    description?: string;
    children?: React.ReactNode;
    prefix?: string;
    tag?: string;
    items?: IBreadcrumbItems[];
    licenseTag?: React.ReactNode;
}

export default function PageHeader({
    title = '',
    description,
    children,
    prefix,
    tag,
    items,
    licenseTag,
}: IPageHeaderProps) {
    const { t } = useTranslation();
    const { managedOrgId } = useParams();
    if (managedOrgId) tag = t('common:organization.managed.titleShort');

    return (
        <>
            {items && <Breadcrumb items={items} />}
            <HeaderWrapper>
                <HeaderTextWrap>
                    {prefix && <LightSmall>{prefix}</LightSmall>}
                    {tag && <Tag>{tag}</Tag>}
                    {licenseTag}
                    {typeof title == 'string' ? <DisplayLarge>{title}</DisplayLarge> : title}
                    {description && <BodyMedium>{description}</BodyMedium>}
                </HeaderTextWrap>
                {children && <HeaderChildWrap>{children}</HeaderChildWrap>}
            </HeaderWrapper>
        </>
    );
}

const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1rem;
`;
